/**
 * "Updated <Month D, YYYY>" / "New" label shown next to a channel-rate row in
 * the rate edit forms (panel OverviewTab + dashboard EstPriceCell popover), so
 * the per-ad-type last-edit date reads identically in both places. Mirrors the
 * v1 admin, which surfaced this date beside every rate. `updatedAt` is the
 * per-type timestamp (`ratesV2.items[].updatedAt`); a row with none is unsaved
 * ("New"). Date format is en-US to match the existing v2 rate edit UI.
 */
export function RateUpdatedLabel({ updatedAt }: { updatedAt?: string | null }) {
  if (!updatedAt) return <span className="text-[10px] text-ggc-disabled italic">New</span>;
  return (
    <span className="text-[10px] text-ggc-disabled whitespace-nowrap">
      Updated {new Date(updatedAt).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
    </span>
  );
}
